import { createSlice } from '@reduxjs/toolkit'

export const paymentsSilce = createSlice({
    name: "payments",
    initialState: {
        openCheckout: false,
        clientSecret: "",
        sessionId: "",
        amount: 0,
    },
    reducers: {
        openCheckout: (state, action) => {
            const { clientSecret, sessionId } = action.payload;
            state.clientSecret = clientSecret || state.clientSecret;
            state.sessionId = sessionId || state.sessionId;
            state.amount = action.payload.amount || state.amount;
            state.openCheckout = true;
        }
    }
})

// Action creators are generated for each case reducer function
export const { openCheckout } = paymentsSilce.actions

export default paymentsSilce.reducer